import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { User } from '@utils/backend-api/currentUser';
import { OfferOption } from '@utils/backend-api/subscribe';

import Context from './Context';

const queryClient = new QueryClient();

interface GiftLandingForLeadProps {
  initialCurrentUser: User;
  isGdprRequired: boolean;
  offers: OfferOption[];
  stripeCustomerId: string;
  userEmail: string;
}

const GiftLandingForLead = ({
  initialCurrentUser,
  isGdprRequired,
  offers,
  stripeCustomerId,
  userEmail,
}: GiftLandingForLeadProps) => {
  return (
    <AppContextProvider initialCurrentUser={initialCurrentUser} isGdprRequired={isGdprRequired}>
      <SubscribeFormProvider
        user={{
          email: userEmail,
          stripeCustomerId,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <Context offers={offers} />
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default GiftLandingForLead;
